/* istanbul ignore file */
// libs
import React from 'react';
// components
import { Show } from 'framework/show';
// services
import { useLeadId } from 'domain/sales/lead/leadRouting';
import useLeadService from 'domain/sales/lead/shared/leadService';

const ShowLead = ({ children = null }: { children?: React.ReactNode }) => {
  const id = useLeadId();
  const { getById, visit } = useLeadService();

  return (
    <Show
      getDataMethod={() => {
        visit(id);
        return getById(id);
      }}
    >
      {children}
    </Show>
  );
};

export default ShowLead;
